import { api } from "../utils/apiClient";

export const createReport = (name) => api.post("/perception-reports", { name });

export const listReports = () => api.get("/perception-reports");

export const getReport = (reportId, config) =>
  api.get(`/perception-reports/${reportId}`, false, config);

export const getPerceptionTrend = () => api.get("/perception-reports/trend");
